module.exports = __webpack_public_path__ + "img/polyurethane.01995063.jpg";